import { DesignData } from 'src/store/design/types';

const countNumberOfPages = (designData: DesignData) => (
  designData.spreads.reduce((pagesCount, spread) => pagesCount + spread.pages.length, 0)
);

export default countNumberOfPages;
